import * as React from 'react';
import { ContentfulAsset } from 'model/contentful/asset';
import Heading from 'components/text/Heading';
import { useTranslation } from 'next-i18next';
import View from 'components/View';
import Link from 'components/Link';
import { ChevronDown } from 'lucide-react';
import HeroImage from 'components/HeroImage';

interface Props {
  heroImage: ContentfulAsset;
}

const BecomePartnerHero: React.FC<Props> = ({ heroImage }) => {
  const { t } = useTranslation();
  return (
    <HeroImage src={heroImage?.url} overlayClass="!bg-[#171717]/[0.4]">
      <View className="flex flex-col h-full w-full justify-center">
        <div className="max-w-[600px] mx-auto">
          <Heading variant="h1" className="text-white !text-4xl md:!text-5xl text-center ">
            {t('becomePartner.heroText')}
          </Heading>
        </div>
      </View>
      <View className="-mt-12 flex justify-center">
        <Link className="text-white flex text-sm font-medium items-center" href="#supportForm">
          {t('contact.getInTocuch')}
          <ChevronDown className="ml-2 text-white" size={15} />
        </Link>
      </View>
    </HeroImage>
  );
};

export default BecomePartnerHero;
